import { Badge, formatNumber, Image } from "@";

// Columns configuration for latest donations table
export const latestDonationsColumns = [
  {
    name: "",
    grow: 0,
    cell: ({ recentDonations }) => <Image src={recentDonations[0]?.image} />,
  },

  {
    name: "العنوان",
    selector: ({ recentDonations }) => recentDonations[0]?.title,
  },

  {
    name: "	المبلغ المطلوب",
    selector: ({ recentDonations }) =>
      formatNumber(recentDonations[0]?.requiredAmount),
  },

  {
    name: "عدد التبرعات",
    selector: ({ recentDonations }) =>
      formatNumber(recentDonations[0]?.totalDonations),
  },

  {
    name: "التصنيفات",
    selector: ({ recentDonations }) => recentDonations[0]?.classifications,
  },

  {
    name: "الحالة",
    cell: ({ recentDonations }) => (
      <Badge
        title={recentDonations[0]?.isActive ? "مفعل" : "غير مفعل"}
        color={recentDonations[0]?.isActive ? "green" : "red"}
      />
    ),
  },
];

// Columns configuration for general report table A
export const generalReportColumnsA = [
  {
    name: "المشروع",
    selector: ({ projectName }) => projectName,
  },

  {
    name: "إجمالي التبرعات",
    selector: ({ totalDonationsCount }) => formatNumber(totalDonationsCount),
  },
];

// Columns configuration for general report table B
export const generalReportColumnsB = [
  {
    name: "رقم جوال المتبرع",
    selector: ({ phoneNumber }) => phoneNumber,
  },

  {
    name: " عدد الطلبات",
    selector: ({ totalDonationsCount }) => formatNumber(totalDonationsCount),
  },
];
